const formatCountryDropDown = function (state) {
    let $state = undefined;
    if (!state.id) {
        return state.text;
    }
    $state = $('<span><img src="' + state.element.dataset.flagPath + '" class="img-flag select2-flag-img" /> ' + state.text + '</span>');
    return $state;
};

const formatCountrySelected = function (state) {
    if (!state.id) {
        return state.text;
    }
    const $state = $('<span><img class="img-flag select2-flag-img" /> <span></span></span>');
    if (state.element.dataset.callingCode) {
        $state.find('span').text(state.element.dataset.callingCode);
    } else {
        $state.find('span').text(state.text);
    }

    $state.find('img').attr('src', state.element.dataset.flagPath);
    return $state;
};

export const initSelect2OnElement = function (element, options = {}) {
    return $(element).select2(options);
}

export const initCountrySelect2 = function (selector = '.country-select2') {
    $(selector).select2({
        templateResult: formatCountryDropDown,
        templateSelection: formatCountrySelected,
        dropdownAutoWidth: true,
        matcher: function(params, data) {
            if ($.trim(params.term) === '') {
                return data;
            }

            if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) {
                return data;
            }

            return null;
        }
    });
}

export const initCertificateSelect2 = function (selector = '.multi-select2-certificates', selectOptions = {}) {
    $(selector).select2({
        tags: true,
        selectOptions
    })
}

export const initMultiSelect2 = function (multiSelectName = '.multi-select2', selectOptions = {}) {
    $(multiSelectName).select2(selectOptions);
}

export const initLocaleSelect2 = function () {
    const $localeSelect = $('.locale-select');

    $localeSelect.select2({
        minimumResultsForSearch: Infinity,
        templateResult: formatCountryDropDown,
        templateSelection: formatCountrySelected,
        dropdownAutoWidth: true,
        width: 'style'
    });

    $localeSelect.each(function () {
        const select2Container = $(this).next('.select2-container');
        select2Container.addClass('locale-select2');
    });
}

export const initTreeDropdown = function (selector = '.tree-dropdown', selectOptions = {}) {
    $(selector).each(function () {
        const data = $(this).data().options;
        $(this).select2({
            data: $(this).data().options,
            placeholder: $(this).data().placeholder
        });
    })
}

export const initDynamicElements = function () {
    setTimeout(function () {
        $(document).bind('DOMNodeInserted', function (e) {
            var elements = $(e.target).find(".multi-select2");
            if (elements.length > 0) {
                initSelect2OnElement(elements);
            }
        });
    }, 2000);
}

$(() => {
        initCountrySelect2();
        initMultiSelect2();
        initDynamicElements();
        initTreeDropdown();
        initCertificateSelect2();
        // specs/013-supplier-client-normalization — reuses the certificates selector's tags:true
        // config verbatim: recognized options come from the rendered <option> list, and typing an
        // unmatched value lets the supplier add it as a free-text entry.
        initCertificateSelect2('.multi-select2-supplier-clients');
        // specs/014-client-countries-supplied — reuses the flag-icon country-select2 config (a
        // closed catalog with no free-text path, research.md Decision 4) for the per-client-row
        // countries-supplied selector.
        initCountrySelect2('.multi-select2-client-countries');
        initLocaleSelect2();
    }
);
